import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "smallIcon icon-pfeil-links iconInButton" }, null, -1)
const _hoisted_4 = { class: "block w-full registrationUserHistory" }
const _hoisted_5 = { class: "historyDetails" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 w-full"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end" }, null, -1)

import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Store, StringHelper} from "@bryntum/grid";
import {onMounted, reactive, ref} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import dialog from "@/dialog";
import isNullOrUndefined from "@/utilities/helpers/NullOrUndefinedHelper";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {DisdiStateType, ErrorLocationType, PopupType, TableType} from "@/utilities/enums/Enums";
import {RegistrationService} from "@/utilities/services/entities/RegistrationService";
import {PermissionService} from "@/utilities/services/PermissionService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import router from "@/router";
import { ClientIconHelper } from '@/utilities/helpers/ClientIconHelper';




    
export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationUserHistory',
  setup(__props) {

const clientText = (r:any) =>
        (r === '1anabapp') ? "1ANAB-App" : (r === 'manuelleanabmeldung') ? "Manuell (Admin)":r;

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();


const permissionService = new PermissionService();
const registrationService = new RegistrationService();

const selectedUser = ref(globalStore.modal.contentObject.userData ?? globalStore.modal.contentObject);

const backLocation = ref(undefined);
const goBackToLocationHistoryPopup = () => {
  if (backLocation.value !== undefined) {
    globalStore.openPopup({
      data: backLocation.value,
      action: globalStore.closeModal,
      title: backLocation.value.name,
      type: PopupType.locationReportsDetailsPopup
    }, true);
  }
};

const grid = ref(null);
const useGridConfig = {
  autoHeight : true,
  headerMenuFeature: false,
  enableTextSelection: true,
  cellTooltipFeature: {
    hoverDelay: 300,
    textContent: true,
    hideOnDelegateChange: true,
  },
  columns : {
      data: [
          {
              id: 'client', field: 'client', text: t('locationsReports.grid.client'), flex: 1, type: 'template',
              template: ({ record }) => StringHelper.xss`${clientText(record.data.client)}` },
      {
        id: 'status',
        field: 'status',
        text: "",
        width: 36,
        minWidth: 36,
        type: "template",
        template: ({ record }) => {
          const isActive = record.data.lastUnRegisteredLocationDate === null;
          return isActive
              ? `<div class="userActivity isActive"></div>`
              : `<div class="userActivity"></div>`;
        },
      },
      {
        id: 'locationName',
        field : 'locationName',
        text: t('registrationReports.grid.location'),
        flex   : 1,
        sortable: true
      },
          {
              id: 'lastRegisteredLocationDate',
              field: 'lastRegisteredLocationDate',
              text: t('registrationReports.grid.register'),
              flex: 1,
              sortable: true,
              type: 'template',
              template: ({ record }) => {
                  if (NullOrUndefinedHelper(record.data.lastRegisteredLocationDate)) {
                      return '';
                  }

                  const icon = ClientIconHelper.getIcon(record.data.client);
                  const tooltip = (record.data.client);

                  if (record.data.hideDates) {
                      return `<span title="${tooltip}">${icon}</span>`;
                  }

                  const date = DateToStringHelper(
                      new Date(record.data.lastRegisteredLocationDate)
                  );

                  return `${date} <span title="${tooltip}">${icon}</span> `;
              }
          },
          {
              id: 'lastUnRegisteredLocationDate',
              field: 'lastUnRegisteredLocationDate',
              text: t('registrationReports.grid.unregister'),
              flex: 1,
              sortable: true,
              type: 'template',
              template: ({ record }) => {
                  if (NullOrUndefinedHelper(record.data.lastUnRegisteredLocationDate)) {
                      return '';
                  }

                  const icon = ClientIconHelper.getIcon(
                      record.data.unregistrationClient,
                      record.data.unRegistrationReason
                  );

                  const tooltip = (record.data.unregistrationClient ?? record.data.unRegistrationReason);

                  if (record.data.hideDates) {
                      return `<span title="${tooltip}">${icon}</span>`;
                  }

                  const date = DateToStringHelper(
                      new Date(record.data.lastUnRegisteredLocationDate)
                  );

                  return `${date} <span title="${tooltip}">${icon}</span> `;

              }
          },
      {
        id: 'locationPhoneNumber',
        field : 'locationPhoneNumber',
        text: t('registrationReports.grid.phoneNumber'),
        flex   : 1,
        sortable: true
      },
      {
        id:'hasDisdi',
        field:'hasDisdi',
        text	: "",
        width   : 36,
        type	: 'template',
        align: "center",
        hidden: !permissionService.userHasPermission("Disdi.Read"),
        resizable: false,
        filterable: false,
        template : ({record}:any)=> {
          return record.data.hasDisdi && record.data.disdiCount > 0
              ? `<div class='gridRowButton'><span class='icon-liste_tagebuch'></span></div>`
              : record.data.hasDisdi && record.data.disdiCount === 0
                  ? `<div class='gridRowButtonDisabled'><span class='icon-liste_tagebuch'></span></div>`
                  : "";
        }
      },
      {
        id: 'activityText',
        field: 'activityText',
        hidden: !globalStore.settings.activitySettings?.activitesEnabled,
        text: '',
        width   : 52,
        minWidth: 36,
        type: "template",
        tooltipRenderer : ({ record }) => isNullOrUndefined(record.data.activityText) ? "" : StringHelper.xss`<b>${t('registrationReports.grid.activity')}</b><br/>${record.data.activityText ?? ""}<br/>`,
        template: ({record}) => {
          return isNullOrUndefined(record.data.activityText)
              ? ""
              : `<div class='gridTooltipButton'><span class='icon-activity'></span></div>`;
        },
      },
      {
        id: 'unregister',
        field : 'unregister',
        text: "",
        width   : 52,
        minWidth: 36,
        type: "template",
        template: ({record}) => {
          return record.data.lastUnRegisteredLocationDate === null
              ? `<div class='gridRowButton'><span class='icon-abmelden'></span></div>`
              : "";
        },
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.userRegistrationHistory], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    async cellClick({column, record}) {
      if (column.data.field === 'unregister' && record.data.lastUnRegisteredLocationDate === null) {
        const answer = await dialog
            .okText(t("global.unregister"))
            .cancelText(t("global.cancel"))
            .confirm(t("registrationReports.confirmUnregister", { name:selectedUser.value.fullName, location:record.data.locationName}));

        if (answer){
          const unregResp = await registrationService.postUnRegisterUser(selectedUser.value.id, record.data.locationId);
          if(unregResp === null || unregResp === undefined || unregResp?.statusCode !== 0){
            ErrorHandler.handleError(unregResp, ErrorLocationType.popup);
            return;
          }

          // update grid in popup
          record.data.lastUnRegisteredLocationDate = new Date().toJSON();
          gridStore.add(record.data);

          // update reportGrid if current view is registerReports
          if(router.currentRoute.value.name === "RegistrationReports"){
            const userEntry = globalStore.gridStore.records.find(u => u.id === selectedUser.value.id).data;
            userEntry.registeredLocationInfo = userEntry.registeredLocationInfo.map(r => {
              if(r.lastUnRegisteredLocationDate === null) r.lastUnRegisteredLocationDate = new Date().toJSON();

              return r;
            });
            const reg = DateToStringHelper(new Date(record.data.lastRegisteredLocationDate));
            const unreg = DateToStringHelper(new Date(record.data.lastUnRegisteredLocationDate));
            userEntry.lastRegistrationTime = `${reg} → ${unreg}`;
            userEntry.isActive = false;

            globalStore.gridStore.add(userEntry);
          }
        }
      }

      if(column.data.field === "hasDisdi"){    
        const rd = record.data;
        
        if (!rd.hasDisdi || rd.disdiCount===0) return;          
          globalStore.setDisdiContext(rd);
          await router.push(`disdi/${TableType[TableType.register]}/${+rd.registrationId}`);
      }

    },
  }
}

const gridConfig = reactive(useGridConfig);

const setDisdiColumVisibility = async() =>{
  const disdiIsOn = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;

  if(!disdiIsOn){
    const hasDisdiCol = grid.value.instance.value.columns.getById("hasDisdi");
    hasDisdiCol.hidden = true;
  }
}

onMounted(async () => {
  const popupData = globalStore.modal.contentObject;
  const gridData = popupData.userData?.registeredLocationInfo ?? popupData.registeredLocationInfo;

  backLocation.value = popupData.backLocation ?? undefined;

  gridStore.setStoreData(gridData);

  await setDisdiColumVisibility();

  globalStore.reorderColumns(TableType[TableType.userRegistrationHistory], grid.value.instance.value.columns);

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (backLocation.value !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", { onClick: goBackToLocationHistoryPopup }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('global.back')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", null, _toDisplayString(selectedUser.value.fullName), 1),
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(selectedUser.value.companyName) + " ", 1),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_unref(t)('registrationReports.email')) + ": ", 1),
        _createElementVNode("a", {
          href: 'mailto:'+selectedUser.value.email
        }, _toDisplayString(selectedUser.value.email), 9, _hoisted_7),
        _createTextVNode(),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_unref(t)('registrationReports.phoneNumber')) + ": ", 1),
        _createElementVNode("a", {
          href: 'tel:'+selectedUser.value.phoneNumber
        }, _toDisplayString(selectedUser.value.phoneNumber), 9, _hoisted_9)
      ]),
      (backLocation.value === undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(BryntumGrid), _mergeProps({
              ref_key: "grid",
              ref: grid
            }, gridConfig, { readOnly: true }), null, 16)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})